export const environment = {
  production: true,
  api: {
    PASSWORD_RETURN_URL: 'https://admin.baxi-services.com/update-password',
    KEY: 'uywweiwe7820-nsjusb897wqbhas',
    // BASE_URL: 'http://197.255.63.149:5002/api/'
    BASE_URL: 'https://api.baxi-services.com/api/'
  }
};
